const key = "add-vessel-entity-data";

const applicable = (resp) => {
	return resp.config.method === "GET" && resp.config.url.match(/api\/forms\/131\/entities\/5939$/);
};

const extendedProperties = {
	SimpleValue: "This is a simple value",
	Engine: {
		Horsepower: 100
	},
	Electronics: {
		SideScanSonar: true,
		Fathometer: false
	},
	Lighting: {
		AttractingLightsUsed: [
			{
				type: "Type 1",
				wattage: 50,
				number: 2
			},
			{
				type: "Type 2",
				wattage: 100,
				number: 1
			}
		]
	}
};

const applyExtendedProperties = (dataItem) => ({
	...dataItem,
	...extendedProperties
});

const modify = (resp) => {
	if(Array.isArray(resp.data.Data)) {
		resp.data.Data = resp.data.Data.map(applyExtendedProperties);
		return resp;
	}

	if(resp.data.Data) {
		resp.data.Data = applyExtendedProperties(resp.data.Data);
	}

	return resp;
};

export const addVesselEntityData = [key, applicable, modify];